import React from "react";
import { ActivateFeatureButton, FlexContainer, TextLabel } from "src/components";
import NewCampaign from "src/img/new_campaign.svg";
import { EMAIL_STATUS } from "../../constants";

export default function NoData(props) {
    const { startNewEmail, emailStatus = EMAIL_STATUS.SENT, hasScheduledOrDraft } = props;

    if (emailStatus === EMAIL_STATUS.DRAFT || emailStatus === EMAIL_STATUS.SCHEDULED) {
        return (
            <FlexContainer
                justifyContent="center"
                alignItems="center"
                border="1px solid #D8DEEC"
                borderRadius="15px"
                color="#FFFFFF"
                height="139px"
                style={{ boxShadow: "0px 5px 5px #0000001A" }}
            >
                <TextLabel
                    weight="700"
                    size="20px"
                    align="center"
                    color="#171A22"
                    style={{ textTransform: "capitalize" }}
                >
                    {`No ${emailStatus} Campaigns Available.`}
                </TextLabel>
            </FlexContainer>
        );
    }

    return (
        <FlexContainer
            justifyContent="center"
            alignItems="center"
            border="1px solid #D8DEEC"
            borderRadius="15px"
            color="#FFFFFF"
            height="330px"
            style={{ boxShadow: "0px 5px 5px #0000001A" }}
        >
            <FlexContainer justifyContent="center" alignItems="center" maxWidth="593px" gap="10px">
                <img src={NewCampaign} alt="No Data" width={80} height={80} />
                <TextLabel size="20px" weight="700" color="#171A22" align="center">
                    {hasScheduledOrDraft
                        ? "Create Another Email Campaign"
                        : "Create Your First Email Campaign"}
                </TextLabel>
                <TextLabel weight="500" size="16px" align="center">
                    {hasScheduledOrDraft
                        ? "You already have an email campaign saved as a draft or scheduled to be sent. You can create a new campaign anytime to continue engaging your audience."
                        : "Start engaging your audience with professional email campaigns. Create, schedule, and send emails to your users or contacts in just a few clicks."}
                </TextLabel>
            </FlexContainer>
            <FlexContainer>
                <ActivateFeatureButton
                    width="184px"
                    height="39px"
                    onClick={startNewEmail}
                    style={{ marginTop: "25px" }}
                >
                    {hasScheduledOrDraft ? "Create Another Campaign" : "Create New Campaign"}
                </ActivateFeatureButton>
            </FlexContainer>
        </FlexContainer>
    );
}
